import { z } from "zod";
const DTODocumentationStructureItemType = z.enum(["Group", "Page"]);
const DTODocumentationStructureItemBase = z.object({
    type: DTODocumentationStructureItemType,
    id: z.string(),
    designSystemVersionId: z.string(),
    shortPersistentId: z.string(),
    persistentId: z.string(),
    title: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const DTODocumentationStructureGroupItem = DTODocumentationStructureItemBase.extend({
    type: z.literal(DTODocumentationStructureItemType.enum.Group),
    groupBehavior: z.string(),
    childrenIds: z.string().array(),
    isRoot: z.boolean(),
});
export const DTODocumentationStructurePageItem = DTODocumentationStructureItemBase.extend({
    type: z.literal(DTODocumentationStructureItemType.enum.Page),
    path: z.string(),
});
export const DTODocumentationStructureItem = z.discriminatedUnion("type", [
    DTODocumentationStructureGroupItem,
    DTODocumentationStructurePageItem,
]);
export const DTODocumentationStructure = z.object({
    items: z.array(DTODocumentationStructureItem),
});
